import React from 'react';
import { getFormaPagoTexto } from '../../../utils/formasPago';

function VistaPreviaDocumentoSoportePDF({ 
    documento, 
    client, 
    proveedor, 
    encabezadoPersonalizado,
    creador
}) {
    // Funciones auxiliares
    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const anio = String(date.getFullYear()).slice(-2);
        return `${dia}/${mes}/${anio}`;
    };

    const obtenerNitProveedor = () => {
        if (proveedor?.numero_documento) {
            return proveedor.dv
                ? `${proveedor.numero_documento}-${proveedor.dv}`
                : proveedor.numero_documento;
        }
        return '';
    };

    const getMetodoPagoTexto = (codigo) => getFormaPagoTexto(codigo);

    const formatearMoneda = (valor) => {
        return Math.round(parseFloat(valor || 0)).toLocaleString('es-CO');
    };

    // Estilos inline
    const estilosContenedor = {
        fontFamily: 'Arial, sans-serif',
        fontSize: '9px',
        color: '#282828',
        backgroundColor: '#ffffff',
        padding: '15mm',
        maxWidth: '210mm',
        margin: '0 auto'
    };

    const estilosBanner = {
        backgroundColor: '#e9ecef',
        padding: '4px 8px',
        fontWeight: 'bold',
        fontSize: '10px',
        textAlign: 'center',
        border: '1px solid #dee2e6',
        marginBottom: '8px'
    };

    const estilosTabla = {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '8px',
        fontSize: '9px'
    };

    const estilosCelda = {
        border: '1px solid #dee2e6',
        padding: '4px'
    };

    const estilosCeldaEncabezado = {
        ...estilosCelda,
        backgroundColor: '#e9ecef',
        fontWeight: 'bold',
        width: '15%'
    };

    const estilosCeldaDato = {
        ...estilosCelda,
        backgroundColor: '#ffffff'
    };

    const estilosTablaItems = {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '8px',
        fontSize: '9px'
    };

    const estilosTh = {
        border: '1px solid #dee2e6',
        padding: '4px',
        backgroundColor: '#e9ecef',
        fontWeight: 'bold',
        textAlign: 'left',
        fontSize: '9px'
    };

    const estilosTd = {
        border: '1px solid #dee2e6',
        padding: '3px',
        fontSize: '9px'
    };

    const estilosTotales = {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '10px'
    };

    const estilosTotalFinal = {
        borderTop: '2px solid #dee2e6',
        fontWeight: 'bold',
        fontSize: '10px'
    };

    const estilosNotaLegal = {
        marginTop: '10px',
        fontSize: '7px',
        lineHeight: '1.3',
        color: '#666',
        textAlign: 'justify'
    };

    // Funciones de renderizado
    const renderEncabezado = () => {
        if (encabezadoPersonalizado && encabezadoPersonalizado.estado === 1) {
            return (
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '8px', backgroundColor: '#ffffff' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '30%', padding: '2px', fontSize: '9px', lineHeight: '1.1', verticalAlign: 'top', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{ __html: encabezadoPersonalizado.izquierda }} />
                            <td style={{ width: '40%', padding: '2px', textAlign: 'center', fontSize: '10px', lineHeight: '1.1', verticalAlign: 'top', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{ __html: encabezadoPersonalizado.centro }} />
                            <td style={{ width: '30%', padding: '2px', textAlign: 'right', fontSize: '9px', lineHeight: '1.1', verticalAlign: 'top', wordWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{ __html: encabezadoPersonalizado.derecha }} />
                        </tr>
                    </tbody>
                </table>
            );
        }
        return null;
    };

    const renderDatosDocumento = () => (
        <>
            <div style={estilosBanner}>
                DOCUMENTO SOPORTE N° {documento.prefijo}-{documento.numero}
            </div>
            <table style={estilosTabla}>
                <tbody>
                    <tr>
                        <td style={estilosCeldaEncabezado}>DOCUMENTO #</td>
                        <td style={estilosCeldaDato}>{documento.numero}</td>
                        <td style={estilosCeldaEncabezado}>PREFIJO</td>
                        <td style={estilosCeldaDato}>{documento.prefijo || 'N/A'}</td>
                        <td style={estilosCeldaEncabezado}>FECHA EMISIÓN</td>
                        <td style={estilosCeldaDato}>{formatearFecha(documento.fecha_emision)}</td>
                    </tr>
                    <tr>
                        <td style={estilosCeldaEncabezado}>FORMA DE PAGO</td>
                        <td colSpan="3" style={estilosCeldaDato}>{getMetodoPagoTexto(documento.forma_pago)}</td>
                        <td style={estilosCeldaEncabezado}>TIPO PAGO</td>
                        <td style={estilosCeldaDato}>{documento.tipo_pago === 'pagada' ? 'Pagada' : 'Por Pagar'}</td>
                    </tr>
                    <tr>
                        <td style={estilosCeldaEncabezado}>CREADO POR</td>
                        <td colSpan="5" style={estilosCeldaDato}>{creador?.name || 'N/A'}</td>
                    </tr>
                </tbody>
            </table>
        </>
    );

    const renderDatosProveedor = () => (
        <table style={estilosTabla}>
            <tbody>
                <tr>
                    <td style={estilosCeldaEncabezado}>PROVEEDOR</td>
                    <td colSpan="3" style={estilosCeldaDato}>{proveedor?.nombre_proveedor || 'N/A'}</td>
                </tr>
                <tr>
                    <td style={estilosCeldaEncabezado}>NIT/DOCUMENTO</td>
                    <td style={estilosCeldaDato}>{obtenerNitProveedor()}</td>
                    <td style={estilosCeldaEncabezado}>TELÉFONO</td>
                    <td style={estilosCeldaDato}>{proveedor?.telefono || proveedor?.celular || ''}</td>
                </tr>
                <tr>
                    <td style={estilosCeldaEncabezado}>EMAIL</td>
                    <td style={estilosCeldaDato}>{proveedor?.email || ''}</td>
                    <td style={estilosCeldaEncabezado}>DIRECCIÓN</td>
                    <td style={estilosCeldaDato}>{proveedor?.direccion || ''}</td>
                </tr>
                {documento.uedi && (
                    <tr>
                        <td style={estilosCeldaEncabezado}>UEDI</td>
                        <td colSpan="3" style={{ ...estilosCeldaDato, fontSize: '8px', wordBreak: 'break-all' }}>{documento.uedi}</td>
                    </tr>
                )}
            </tbody>
        </table>
    );

    const renderTablaItems = () => (
        <table style={estilosTablaItems}>
            <thead>
                <tr>
                    <th style={{ ...estilosTh, width: '8%' }}>Código</th>
                    <th style={{ ...estilosTh, width: '35%' }}>Descripción</th>
                    <th style={{ ...estilosTh, width: '8%', textAlign: 'center' }}>Cant.</th>
                    <th style={{ ...estilosTh, width: '13%', textAlign: 'right' }}>Precio Unit.</th>
                    <th style={{ ...estilosTh, width: '8%', textAlign: 'center' }}>Desc.</th>
                    <th style={{ ...estilosTh, width: '8%', textAlign: 'center' }}>IVA</th>
                    <th style={{ ...estilosTh, width: '15%', textAlign: 'right' }}>Total</th>
                </tr>
            </thead>
            <tbody>
                {documento.detalle?.map((item, index) => {
                    const lineTotal = item.vrunitario * item.cantidad;
                    const descuento = lineTotal * (item.descuento / 100);
                    const baseImponible = lineTotal - descuento;
                    const iva = baseImponible * (item.iva / 100);
                    const total = baseImponible + iva;

                    return (
                        <tr key={index}>
                            <td style={estilosTd}>{item.concepto_pago?.codigo || ''}</td>
                            <td style={estilosTd}>{item.concepto_pago?.nombre || ''}</td>
                            <td style={{ ...estilosTd, textAlign: 'center' }}>{item.cantidad}</td>
                            <td style={{ ...estilosTd, textAlign: 'right' }}>${formatearMoneda(item.vrunitario)}</td>
                            <td style={{ ...estilosTd, textAlign: 'center' }}>{item.descuento}%</td>
                            <td style={{ ...estilosTd, textAlign: 'center' }}>{item.iva}%</td>
                            <td style={{ ...estilosTd, textAlign: 'right', fontWeight: 'bold' }}>${formatearMoneda(total)}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );

    const renderTotales = () => {
        const subtotal = parseFloat(documento.valor_bruto);
        const total = parseFloat(documento.valor_total);
        
        return (
            <div style={estilosTotales}>
                <table style={{ width: 'auto', borderCollapse: 'collapse', fontSize: '9px' }}>
                    <tbody>
                        <tr>
                            <td style={{ textAlign: 'right', padding: '4px 12px 4px 4px', fontWeight: 'bold' }}>Subtotal:</td>
                            <td style={{ textAlign: 'right', padding: '4px', minWidth: '100px' }}>${formatearMoneda(subtotal)}</td>
                        </tr>
                        <tr style={estilosTotalFinal}>
                            <td style={{ textAlign: 'right', padding: '6px 12px 6px 4px', fontWeight: 'bold' }}>Total:</td>
                            <td style={{ textAlign: 'right', padding: '6px', fontWeight: 'bold' }}>${formatearMoneda(total)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div id="documento-soporte-pdf-editable" style={estilosContenedor}>
            {/* Encabezado */}
            {renderEncabezado()}
            
            {/* Datos del documento */}
            {renderDatosDocumento()}
            
            {/* Datos del proveedor */}
            {renderDatosProveedor()}
            
            {/* Tabla de ítems */}
            {renderTablaItems()}
            
            {/* Totales */}
            {renderTotales()}

            {/* Observaciones */}
            {documento.observaciones && (
                <div style={{ marginTop: '10px' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '9px', marginBottom: '4px' }}>Observaciones:</div>
                    <div style={{ fontSize: '9px' }}>{documento.observaciones}</div>
                </div>
            )}

            {/* Nota legal - Solo para documentos soporte electrónicos */}
            {documento.uedi && (
                <div style={estilosNotaLegal}>
                    <strong>Nota Legal:</strong> Este documento soporte de adquisiciones efectuadas a sujetos no obligados a facturar ha sido generado y transmitido conforme a lo establecido en el Decreto 2242 de 2015 y la Resolución DIAN 000042 de 2020. 
                    El UEDI (Código Único de Documento Electrónico) garantiza la autenticidad e integridad del documento. 
                    Para verificar la validez de este documento electrónico, puede consultar en el portal de la DIAN utilizando el UEDI proporcionado. 
                    Este documento tiene plena validez legal y probatoria de acuerdo con la normativa colombiana vigente.
                </div>
            )}

            {/* UEDI visible y copiable */}
            {documento.uedi && (
                <div style={{ 
                    marginTop: '10px', 
                    padding: '8px', 
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: '3px'
                }}>
                    <div style={{ 
                        fontWeight: 'bold', 
                        fontSize: '8px', 
                        marginBottom: '4px',
                        color: '#000000'
                    }}>
                        UEDI (Código Único de Documento Electrónico):
                    </div>
                    <div 
                        data-uedi-text="true"
                        style={{ 
                            fontSize: '7px', 
                            wordBreak: 'break-all',
                            fontFamily: 'monospace',
                            color: '#000000',
                            lineHeight: '1.4'
                        }}
                    >
                        {documento.uedi}
                    </div>
                </div>
            )}

            <style>{`
                @media print {
                    .page-break {
                        page-break-before: always;
                        page-break-after: auto;
                    }
                    
                    .no-break {
                        page-break-inside: avoid;
                    }
                    
                    table {
                        page-break-inside: auto;
                    }
                    
                    tr {
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }
                    
                    thead {
                        display: table-header-group;
                    }
                    
                    tfoot {
                        display: table-footer-group;
                    }
                }
            `}</style>
        </div>
    );
}

export default VistaPreviaDocumentoSoportePDF;
